import React from 'react'
import {monthlyMeetingElement,Breadcrumb } from './myFunctions';
export default function MonthlyMeetingListEntry({oym,monthlyMeeting,dropBreadcrumb,authenticated}) {
    console.log("MM List Entry authenticated "+authenticated);
    let monthlyMeetingObject=oym.objectRef(monthlyMeeting);
    let monthlyMeetingName=monthlyMeetingObject.name;
    // let montlyMeetingShortName=monthlyMeetingName.split(" ")[0];
    let montlyMeetingShortName=monthlyMeetingName.replace('MONTHLY MEETING','');
    function dropMMBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(montlyMeetingShortName,monthlyMeetingElement(oym,monthlyMeeting,dropBreadcrumb,authenticated)));
    }
    return (
        <div>
            <button onClick={dropMMBreadcrumb}>{monthlyMeetingName}</button>
        </div>
    )
}
